module.exports = __webpack_public_path__ + "static/jorisvoorn_2-9f19719a4d8bab516fdeb1f939e9b4c5.jpg";